import React, { useEffect, useState } from 'react'
import MasterPage from './MasterPage'
import Card from '../controls/Card'
import { GetRegisterStatus } from '../../configurations/crud/opdRegisteredCrud'
import { useToast } from '../controls/Toast/ToastService'
import { MdErrorOutline, MdOutlineAddLocationAlt, MdPhoneInTalk } from 'react-icons/md'
import { IoSearchOutline } from 'react-icons/io5'
import { EDoctorStatusBg, GetEDoctorStatusName } from '../../configurations/enums/EDoctorStatus'
import Dp from './users/Dp'
import StatusContainer from '../controls/StatusContainer'
import { Link, useParams } from 'react-router-dom'
import QRCode from 'react-qr-code'
import Input from '../controls/Input'
import LoadingContainer from '../controls/LoadingContainer'
import moment from 'moment'
import { GetEOpdDaysName } from '../../configurations/enums/EOpdDays'
import { FaHospitalUser } from "react-icons/fa";
import { BsWatch } from "react-icons/bs";
import useGlobalLoader from '../../configurations/useGlobalLoader'

export default function CheckRegistered() {
    const { start, end } = useGlobalLoader()
    const [patientDetails, setPatientDetails] = useState()
    const [doctorDetails, setDoctorDetails] = useState()
    const [doctorStatus, setDoctorStatus] = useState()
    // const [status, setStatus] = useState(null)
    const [loading, setLoading] = useState(false)
    const [refNo, setRefNo] = useState("")
    const toast = useToast()
    const { id } = useParams()

    useEffect(() => {
        if (id) {
            setRefNo(id)
            GetCheck(id)
        }
    }, [])

    const GetCheck = (pram) => {
        setLoading(true)
        start()
        GetRegisterStatus({
            Id: pram
        })
            .then(res => {
                let mdata = res.data
                if (mdata.result.succeeded) {
                    // setStatus(mdata.data)
                    setPatientDetails(mdata.data)
                    setDoctorDetails(mdata.data.user)
                    setDoctorStatus(mdata)
                } else {
                    setPatientDetails()
                    setDoctorDetails()
                    // setStatus(null)
                    toast.open("Invalid ref no", <MdErrorOutline />, "danger")
                }
                setLoading(false)
                end()
            })
            .catch(errors => {
                setPatientDetails()
                setDoctorDetails()
                setLoading(false)
                end()
                toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
            })
    }

    const handleSubmit = (e) => {
        e.preventDefault()
        if (refNo)
            GetCheck(refNo)
        else
            toast.open("Invalid ref no", <MdErrorOutline />, "danger")
    }

    return (
        <MasterPage>
            <div className='mb-4 mx-2 sm:mx-4 flex items-center justify-center'>
                <div className='w-full lg:w-2/3'>
                    <div className="w-full flex-row md:flex px-2 pb-3">
                        <div className="w-full md:mx-2">
                            <Card title={"Check Register"} isBorder={true} borderColor="border-sky-400" isBack={true}>
                                <form onSubmit={handleSubmit} className="space-y-4 my-3">
                                    <div className="flex items-center space-x-2">
                                        <Input
                                            id="search-num"
                                            value={refNo}
                                            onChange={(e) => setRefNo(e.target.value)}
                                            placeholder="Enter Ref No"
                                            Icon={<IoSearchOutline />}
                                        />
                                        <button
                                            type="submit"
                                            className="bg-sky-500 text-white px-4 py-2 rounded hover:bg-sky-600"
                                            disabled={loading}
                                        >
                                            {loading ? "Checking..." : "Check"}
                                        </button>
                                    </div>
                                </form>

                                {/* {status && (
                                    <div className="mt-6 p-4 border border-green-400 rounded bg-green-50">
                                        <h2 className="text-lg font-bold mb-2">Patient Info</h2>
                                        <p><strong>Name:</strong> {status.patientName}</p>
                                        <p><strong>Age:</strong> {status.age}</p>
                                        <p><strong>Address:</strong> {status.patientAddress}</p>
                                    </div>
                                )} */}
                            </Card>
                        </div>
                    </div>

                    <div className="my-5" />

                    {/* Flex wrapper for Patient + Doctor cards */}
                    <div className="w-full flex flex-col md:flex-row px-2 pb-3 gap-4">
                        {loading ?
                            <div className='w-full'>
                                <LoadingContainer text={"Fetching details"} />
                            </div>
                            :
                            <>
                                <div className="w-full xl:w-1/2 md:mx-2">
                                    <Card title={
                                        <div className='w-full flex items-center justify-between'>
                                            <span> Patient Details</span>
                                            {patientDetails && <div className='text-sm'>Date: <span className='font-bold'>{moment(patientDetails.onDate).format("DD-MM-YYYY")}</span></div>}
                                        </div>
                                    } isBorder={true} borderColor="border-green-400 h-full" >
                                        {patientDetails ?
                                            <div className="mt-2 p-4">
                                                <div className='flex flex-col justify-between'>
                                                    <div className='flex justify-between'>
                                                        <div className='text-sm flex flex-col gap-2'>
                                                            <div>Registered Ref Id: <span className='font-semibold'>{patientDetails.id}</span></div>
                                                            <div>Registered Number: <span className='font-semibold text-lg'>{patientDetails.opdNumberAlloted}</span></div>
                                                            <div>
                                                                <div className='mb-2'>Patient Name: </div>
                                                                <span className='font-semibold text-lg uppercase'>{patientDetails.patientName} ({patientDetails.age})</span></div>

                                                        </div>
                                                        <div className='w-24 flex flex-col items-end'>
                                                            <QRCode size="100" value={patientDetails.id} />
                                                            <div className='leading-[9px]'>
                                                                <span className='text-[10px] text-center'>*Take screenshot or click photo for doctor's refrence.</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='mt-2'>
                                                        <div className="flex items-center text-sm text-gray-700 w-full">
                                                            <FaHospitalUser className="text-red-500 mr-1 shrink-0" />
                                                            <div>Center: <span className='font-semibold'>{patientDetails.opdCenter.centerName}</span>
                                                            </div>
                                                        </div>
                                                        <div className="flex items-center text-sm text-gray-700">
                                                            <MdPhoneInTalk className="text-green-500 mr-2" />
                                                            <span>{patientDetails.opdCenter.phone}</span>
                                                        </div>
                                                        <div className="flex items-baseline text-sm text-gray-700 w-full">
                                                            <MdOutlineAddLocationAlt className="text-blue-500 mr-1 shrink-0" />
                                                            <div>
                                                                {patientDetails.opdCenter.address}, {patientDetails.opdCenter.city.name}, {patientDetails.opdCenter.city.state.name}
                                                            </div>
                                                        </div>
                                                        <div className="flex items-center text-sm text-gray-700 w-full">
                                                            <BsWatch className="text-green-500 mr-1 shrink-0" />
                                                            <div>Timing: <span className='text-sm font-semibold'>{moment(patientDetails.opdCenter.opdStartTime).format("LT")} to {moment(patientDetails.opdCenter.opdEndTime).format("LT")}</span>
                                                            </div>
                                                        </div>
                                                        <div className='mt-2 text-xs'>
                                                            नोट: रेजिस्ट्रैशन नंबर आप के द्वारा डॉक्टर के वहाँ लगाया गया नंबर है, आप को अपने नंबर के निकल जाने से पहले नंबर कन्फर्म करना अनिवार्य है, अन्यथा आप का कन्फर्म नंबर रजिस्टर नंबर से अलग हो सकता है।
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            :
                                            <div className='flex items-center justify-center my-4'>
                                                <span className='text-center text-xl text-gray-500'>
                                                    Please put you Reference no to get status!
                                                </span>
                                            </div>
                                        }
                                    </Card>
                                </div>

                                <Link to={doctorDetails ? `/doctor/${doctorDetails.doctorId}` : ""} className="w-full xl:w-1/2 md:mx-2">
                                    <Card title={"Doctor Details"} isBorder={true} borderColor="border-orange-400 h-full">
                                        {doctorDetails ?
                                            <div className="flex flex-row items-start gap-6 pb-1 pt-4">
                                                <div className="flex-shrink-0">
                                                    <Dp user={doctorDetails} height={"h-20"} width={"w-20"} isNewUser={true} />
                                                </div>

                                                <div className="flex flex-col justify-start space-y-2 w-full">
                                                    <h5 className="text-lg lg:text-xl font-medium text-gray-900">
                                                        <div>Dr. {doctorDetails.fullName} <span className='text-gray-500 text-[10px]'>({doctorDetails.degree})</span></div>
                                                        <div className='text-gray-600 text-sm -mt-1'>{doctorDetails.specialisation.name} ({doctorDetails.specialisation.shortName})</div>
                                                    </h5>


                                                    <div className="flex items-center text-sm text-gray-700">
                                                        <MdPhoneInTalk className="text-green-500 mr-2" />
                                                        <span>{doctorDetails.userName}</span>
                                                    </div>

                                                    <div className="text-sm text-gray-700">
                                                        <StatusContainer
                                                            bg={EDoctorStatusBg(doctorStatus.doctorStatus)}
                                                            text={GetEDoctorStatusName(doctorStatus.doctorStatus)}
                                                        />
                                                    </div>

                                                    <div className="text-sm flex flex-col">
                                                        <span>Ongoing Number:</span>
                                                        <span className='text-3xl font-semibold text-red-600'>{doctorStatus.currentPatient ? doctorStatus.currentPatient : <div>Not Available</div>}</span>
                                                    </div>

                                                    <div class="">
                                                        <div class="text-xs flex flex-col gap-1">
                                                            <span>Open's:</span>
                                                            <span className='grid grid-cols-2 sm:grid-cols-3 gap-2'>
                                                                {
                                                                    patientDetails.opdCenter.opdDays.split(',').map((item, index) =>
                                                                        <span className=' px-2 py-1 bg-gray-200 rounded-md'>
                                                                            {GetEOpdDaysName(item.trim())}
                                                                        </span>
                                                                    )
                                                                }
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            :
                                            <div className='flex items-center justify-center my-4'>
                                                <span className='text-center text-xl text-gray-500'>
                                                    Please put you Reference no to get status!
                                                </span>
                                            </div>}
                                    </Card>
                                </Link>
                            </>
                        }
                    </div>
                </div>
            </div>
        </MasterPage>
    )
}
